// @flow

// Lets tracking learn the HTTP status of a failed request without changing the rejection callers get.
// A sink is active only while `run` executes synchronously. Requests read it before their first await,
// so a status that arrives later still reaches the call that started the request.
export type StatusSink = (status: number) => void;

let activeSink: ?StatusSink = null;

export const withStatusSink = <T>(sink: StatusSink, run: () => T): T => {
  const previous = activeSink;
  activeSink = sink;
  try {
    return run();
  } finally {
    activeSink = previous;
  }
};

export const currentStatusSink = (): ?StatusSink => activeSink;
